import React from 'react';

export default function Tooltip({ message, children }) {
  return (
  <div className="group relative flex">
      {children}
      <span className="absolute whitespace-nowrap	top-10 left-1 scale-0 transition-all rounded bg-primary p-2 text-xs text-white group-hover:scale-100">{message}</span>
  </div>
  )
}